import React from 'react';
import './MenuUser.scss';
import { Drawer } from 'antd';
import Header from 'Components/MenuUser/Header/Header';
import OutsideClickHandler from 'Components/Shared/OutsideClickHandler/OutsideClickHandler';

const MenuUser: React.SFC<{ 
  isVisible: boolean;
  onClose: () => void;
  onBack?: () => void;
 }> = ({
  isVisible,
  onClose,
  onBack,
  children,
}) => (
  <Drawer
    width={ 300 }
    closable={ false }
    visible={ isVisible }>
    <OutsideClickHandler onOutsideClick={ onClose }>
      <Header { ... { onBack, onClose } } />
      <div className='menu-user'>
        { children }
      </div>
    </OutsideClickHandler>
  </Drawer>
);

export default MenuUser;


// WEBPACK FOOTER //
// ./src/components/MenuUser/MenuUser.tsx